import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import constants from 'common/helpers/constants'
import { FormattedMessage } from 'sb-react-intl'
import cx from 'classnames'

import Button from 'components/buttons/Button/Button'
import BackNextModal from 'components/modal/BackNextModal/BackNextModal'

import messages from './messages'
import s from './SetGiftDateModal.scss'


class SetGiftDateModal extends Component {

  static propTypes = {
    data: PropTypes.shape({
      onNext: PropTypes.func.isRequired,
      onBack: PropTypes.func.isRequired,
      onChooseSpecificDate: PropTypes.func.isRequired,
    }),
    name: PropTypes.string,
    onClose: PropTypes.func,
  }

  static defaultProps = {
    name: constants.modals.gifts.SetGiftDate,
  }

  handleClose = () => {
    const { name, onClose } = this.props

    actions.models.modals.close(name)

    if (typeof onClose === 'function') {
      onClose()
    }
  }

  goBack = () => {
    const { data: { onBack } } = this.props

    this.handleClose()
    onBack()
  }

  goNext = () => {
    const { data: { onNext } } = this.props

    this.handleClose()
    onNext()
  }

  openDatePicker = () => {
    const { data: { onChooseSpecificDate } } = this.props

    this.handleClose()
    onChooseSpecificDate()
  }

  render() {
    const { name } = this.props

    return (
      <BackNextModal
        name={name}
        nextButtonId="giftNextButton"
        onClose={this.handleClose}
        onBack={this.goBack}
        dataTestId={constants.testIds.modal.setGiftDateModal}
      >
        <FormattedMessage className={s.title} tag="div" {...messages.title} />
        <div className={s.content}>
          <div className={s.box}>
            <div className={cx(s.image, s.emailIcon)} />
            <FormattedMessage className={s.boxTitle} tag="div" {...messages.emailBox.title} />
            <Button
              className={s.button}
              id="giftRightNowButton"
              title={messages.emailBox.buttonTitle}
              sm
              brand
              halfPadding
              fullWidthOnMobile
              onClick={this.goNext}
            />
          </div>
          <div className={s.box}>
            <div className={cx(s.image, s.calendarIcon)} />
            <FormattedMessage className={s.boxTitle} tag="div" {...messages.calendarBox.title} />
            <Button
              className={s.button}
              id="giftDateButton"
              title={messages.calendarBox.buttonTitle}
              sm
              brand
              halfPadding
              fullWidthOnMobile
              onClick={this.openDatePicker}
            />
          </div>
        </div>
      </BackNextModal>
    )
  }
}


export default SetGiftDateModal
